// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--2Q3RK"};